"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.budget", ["nucont.shared"]);
require("./budget.routes");
